export const pieSegmentColors = [
  ['#39156D', '#6A3CA7', '#E3D0FF'],
  ['#005F66', '#46C1BF', '#B7ECED'],
  // TODO: Add 2 more schemas when app will be able to display more then 2 comparisons
];

export default pieSegmentColors;
